import { makeStyles } from '@material-ui/core/styles';

// eslint-disable-next-line import/prefer-default-export
export const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: '66px',
    '& .panel-toggler': {
      visibility: 'hidden',
    },
    '& .MuiPaper-root.error': {
      position: 'absolute',
      top: '66px',
      [theme.breakpoints.only('xs')]: {
        position: 'relative',
        maxHeight: '105px',
        top: '0',
      },
    },
    '& .MuiPaper-root.success': {
      position: 'absolute',
      top: '66px',
      [theme.breakpoints.only('xs')]: {
        position: 'relative',
        maxHeight: '105px',
        top: '0',
      },
    },
  },
  desktopNotification: {
    maxWidth: 1080,
    margin: '0 auto',
    marginTop: '-2px',
  },
  leftPadding: {
    paddingLeft: '3px',
    position: 'fixed',
    bottom: 0,
  },

  notificationContainer: {
    padding: '20px 20px 0px',
    maxWidth: 1440,
    margin: '0 auto',
    color: theme.palette.grey1,
    [theme.breakpoints.up('sm')]: {
      padding: '20px 60px 0px',
    },
    [theme.breakpoints.up('md')]: {
      padding: '20px 50px 0px',
    },
    [theme.breakpoints.up('lg')]: {
      padding: '20px 35px 0px',
    },
    [theme.breakpoints.up('xl')]: {
      padding: '20px 50px 0px',
    },

    [theme.breakpoints.up('1441')]: {
      padding: '20px 0',
    },
  },
}));
